// Error category types based on TOEFL/IELTS scoring criteria
export type ErrorCategory =
  | 'subject-verb-agreement'
  | 'tense'
  | 'article'
  | 'preposition'
  | 'word-form'
  | 'clause-structure'
  | 'punctuation'
  | 'word-choice'
  | 'singular-plural'
  | 'run-on-sentence';

export const ERROR_CATEGORY_LABELS: Record<ErrorCategory, string> = {
  'subject-verb-agreement': '主谓一致',
  'tense': '时态',
  'article': '冠词',
  'preposition': '介词',
  'word-form': '词形',
  'clause-structure': '从句结构',
  'punctuation': '标点',
  'word-choice': '用词',
  'singular-plural': '单复数',
  'run-on-sentence': '连写句',
};

export const ERROR_CATEGORY_COLORS: Record<ErrorCategory, string> = {
  'subject-verb-agreement': '#ef4444',
  'tense': '#f97316',
  'article': '#eab308',
  'preposition': '#22c55e',
  'word-form': '#06b6d4',
  'clause-structure': '#3b82f6',
  'punctuation': '#8b5cf6',
  'word-choice': '#ec4899',
  'singular-plural': '#14b8a6',
  'run-on-sentence': '#f43f5e',
};

export interface GrammarError {
  id: string;
  originalSentence: string;
  correctedSentence: string;
  practiceSentence?: string;
  category: ErrorCategory;
  explanation?: string;
  explanationEn?: string;
  explanationZh?: string;
  essayTitle: string;
  createdAt: string;
}

export interface Essay {
  id: string;
  dbId?: number;
  title: string;
  content: string;
  uploadedAt: string;
  errors: GrammarError[];
  analyzed: boolean;
}

export interface PracticeItem {
  error: GrammarError;
  categories: ErrorCategory[];
  acceptableAnswers: string[];
  sourceErrors: GrammarError[];
  favorite: FavoriteItem | null;
  userAttempt: string;
  isCorrect: boolean | null;
  attempts: number;
}

export type ReviewResult = 'correct' | 'wrong';

export interface FavoriteItem {
  error: GrammarError;
  addedAt: string;
  reviewCount: number;
  lastReviewedAt: string | null;
  reviewStage: number;
  nextReviewAt: string | null;
  lastReviewResult: ReviewResult | null;
  consecutiveCorrect: number;
  wrongCount: number;
  isMastered: boolean;
  masteredAt: string | null;
}
